import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import _ from 'lodash';
import { defaultXAxisFormat } from '../../../../constants/chart-constants';
import { getDeploymentBarColor, getDeploymentBarKeyDescription } from './DeploymentBarsUtils';
import { DeploymentStages } from '../../Tabs/MockServices/Modals/DeploymentInfoModal';

interface Props {
  stages: DeploymentStages;
}

const DeploymentBar = ({ stages }: Props) => {
  //Sum of all stages
  const total = _.reduce(stages, (sum, elem) => sum + elem, 0);

  //For the graph chart
  const mapStagesToSeries = (): any[] => {
    return _.map(stages, (number, key) => {
      const color = getDeploymentBarColor(key);
      return {
        name: getDeploymentBarKeyDescription(key),
        data: [number],
        color: color,
        borderColor: color,
      };
    });
  };

  const options: Highcharts.Options = {
    chart: {
      type: 'bar',
      height: 140,
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: [''],
      dateTimeLabelFormats: defaultXAxisFormat,
    },
    yAxis: {
      min: 0,
      endOnTick: false, // Makes it 100% wide
      max: total, // Makes it 100% wide
      title: {
        text: '',
      },
      labels: {
        format: '{text}s',
      },
    },
    credits: {
      enabled: false,
    },
    legend: {
      reversed: true,
    },
    tooltip: {
      headerFormat: '<div class="mb-2"><strong>{series.name}</strong></div>',
      pointFormat: '<div>{point.y}s</div>',
      useHTML: true,
    },
    plotOptions: {
      series: {
        stacking: 'normal',
        dataLabels: {
          enabled: true,
          formatter: function() {
            const value = this.y;
            return ((value / total) * 100).toFixed(1) + '%';
          },
        },
      },
    },
    series: mapStagesToSeries(),
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default DeploymentBar;
